import { Formik, Form, Field, ErrorMessage } from 'formik';
import ErrorWrapper from './ErrorWrapper';
import LoadingIndicator from './LoadingIndicator';
import styles from '../styles/ContactForm.module.css';
import btnStyles from '../styles/buttons.module.css';
import { CreateLead } from '../mutations';
import { useMutation } from '@apollo/client';
import { UpdateStepWithData } from '../types';

type Props = {
  onNext: UpdateStepWithData;
  jobId: string;
};

type Errors = {
  [key: string]: string;
};

const TellUsMoreForm = ({ onNext, jobId }: Props) => {
  const [createLead] = useMutation(CreateLead);

  const validate = (values): Errors => {
    const errors: Errors = {};

    if (!values.name) {
      errors.name = 'Required';
    }

    if (!values.email) {
      errors.email = 'Required';
    }

    if (!values.phone) {
      errors.phone = 'Required';
    }

    return errors;
  };

  return (
    <div className={styles.contactForm}>
      <h1>Tell us more about you</h1>
      <Formik
        initialValues={{
          name: '',
          email: '',
          phone: '',
        }}
        validate={validate}
        onSubmit={(values, { setSubmitting }) => {
          createLead({
            variables: {
              name: values.name,
              email: values.email,
              phoneNumber: values.phone,
              jobId,
            },
          })
            .then(({ data: { createLead } }) => {
              if (createLead.status === 'success') {
                onNext({ leadToken: createLead.token }, 4);
              } else if (createLead.errors.length) {
                setSubmitting(false);
              } else {
                setSubmitting(false);
              }
            })
            .catch(() => {
              setSubmitting(false);
            });
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <div>
              <label htmlFor="name">Name</label>
              <Field id="name" name="name" placeholder="Name" />
              <ErrorMessage name="name">
                {(msg) => <ErrorWrapper msg={msg} name="name" />}
              </ErrorMessage>

              <label htmlFor="email">Email</label>
              <Field id="email" name="email" placeholder="Email" />
              <ErrorMessage name="email">
                {(msg) => <ErrorWrapper msg={msg} name="email" />}
              </ErrorMessage>

              <label htmlFor="phone">Phone</label>
              <Field id="phone" name="phone" placeholder="Phone number" />
              <ErrorMessage name="phone">
                {(msg) => <ErrorWrapper msg={msg} name="phone" />}
              </ErrorMessage>

              <button className={btnStyles.btnBlue} type="submit" disabled={isSubmitting}>
                {isSubmitting ? <LoadingIndicator fill="none" /> : 'Generate report'}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default TellUsMoreForm;
